module.exports = __webpack_public_path__ + "img/Title GR.26cd85d3.png";